import { useQuery } from '@tanstack/react-query'
import type { UserSummary } from './data'
import { fetchUserSummaries } from './data'
import Table from 'react-bootstrap/Table'
import { format } from 'date-fns'
import { calGrade } from '@/util'
import { useTranslation } from 'react-i18next'
import Badge from 'react-bootstrap/Badge'
import { pointer } from './style.css'

export default function Users() {
  const { t } = useTranslation()
  const {
    data: userSummaries,
    // isLoading,
    // isError,
  } = useQuery<UserSummary[]>({
    queryKey: ['admin', 'user'],
    queryFn: fetchUserSummaries,
    staleTime: 1000 * 60 * 5,
  })
  return (
    <Table hover>
      <thead>
        <tr>
          <th>登録日</th>
          <th>ID</th>
          <th>ユーザー名</th>
          <th>フリガナ</th>
          <th>メール</th>
          <th>学科種別</th>
          <th>学校名</th>
          <th>学科</th>
          <th>コース</th>
          <th>学年</th>
          <th>就職予定年</th>
          <th>興味あり情報</th>
        </tr>
      </thead>
      <tbody>
        {userSummaries?.map((user) => {
          const rowSpan = user.educationHistories.length || 1
          const firstEduHistory = user.educationHistories[0]
          const rows = [
            <tr key={`${user.id}-${firstEduHistory ? firstEduHistory.id : 0}`}>
              <td rowSpan={rowSpan}>{user.createdAt && format(user.createdAt, 'yyyy/MM/dd')}</td>
              <td rowSpan={rowSpan}>{user.id}</td>
              <td rowSpan={rowSpan}>
                {user.lastName} {user.firstName}
              </td>
              <td rowSpan={rowSpan}>
                {user.lastNameFurigana} {user.firstNameFurigana}
              </td>
              <td rowSpan={rowSpan}>
                <a href={`mailto:${user.email}`}>{user.email}</a>
              </td>
              <td>{firstEduHistory && t(`programType.${firstEduHistory.programType}`)}</td>
              <td>{firstEduHistory && firstEduHistory.school.name}</td>
              <td>{firstEduHistory && firstEduHistory.academicProgram?.name}</td>
              <td>{(firstEduHistory && firstEduHistory.academicCourse?.name) ?? 'なし'}</td>
              <td>{firstEduHistory && calGrade(firstEduHistory.enrollmentStartDate)}</td>
              <td>{user.targetEmploymentYear}</td>
              <td rowSpan={rowSpan}>
                {user.bookmarkedCompanies.map((co) => (
                  <div key={co.id} onClick={() => window.open(`/company/${co.id}/view`, '_blank')}>
                    <Badge bg="secondary">{format(co.bookmarkedAt, 'yyyy/MM/dd')}</Badge>{' '}
                    <Badge className={pointer}>{co.name}</Badge>
                  </div>
                ))}
              </td>
            </tr>,
          ]
          if (user.educationHistories.length > 1) {
            rows.push(
              ...user.educationHistories.slice(1).map((edu) => (
                <tr key={`${user.id}-${edu.id}`}>
                  <td>{edu.school.name}</td>
                  <td>{edu.academicProgram?.name}</td>
                  <td>{edu.academicCourse?.name ?? 'なし'}</td>
                  <td>{calGrade(edu.enrollmentStartDate)}</td>
                </tr>
              ))
            )
          }
          return rows
        })}
      </tbody>
    </Table>
  )
}
